export enum TextVariant {
  text = "text",
  header = "header",
  mainHeader = "mainHeader",
  subHeader = "subHeader",
  subHeaderMedium = "subHeaderMedium",
  subHeaderSmall = "subHeaderSmall",
  basicHeader = "basicHeader",
  smallHeader = "smallHeader",
  mainHeaderSubText = "mainHeaderSubText",
}
